
<section>
  <aside v-for="(block, index) in blocks" :key="index" class="block">
    <component :is="block.data.__typename" :block="block.data"></component>
  </aside>
</section>
